/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleAddOrderModal } from 'actions/orderDetailsAction';
import FSBModal from 'components/common/FSBModal';
import AddOrderForm from './AddOrderForm';

const AddOrderDrawer = () => {
  const dispatch = useDispatch();
  const { showAddOrderForm } = useSelector(
    (state) => state.orderDetailsReducer,
  );

  const modalTitle = (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        flex: 1,
        paddingRight: '16px',
        gap: '12px',
      }}
    >
      <span style={{ fontWeight: 600 }}>Add Order</span>
    </div>
  );

  const drawerToggle = () => {
    dispatch(toggleAddOrderModal({ showAddOrderForm: false }));
  };

  return (
    <>
      {showAddOrderForm && (
        <FSBModal
          open={showAddOrderForm}
          size="xl"
          title={modalTitle}
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          toggleAlert={drawerToggle}
          onClose={drawerToggle}
          onConfirmClick={drawerToggle}
          modalClass="right-drawer right-drawer-details"
        >
          <AddOrderForm onClose={drawerToggle} />
        </FSBModal>
      )}
    </>
  );
};

export default AddOrderDrawer;
